import { render, staticRenderFns } from "./ItensExecucao.vue?vue&type=template&id=79d1a4b2&"
import script from "./ItensExecucao.vue?vue&type=script&lang=js&"
export * from "./ItensExecucao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports